import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "edge-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_board_port = _resolveComponent("board-port")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["edge", _ctx.className]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleClick()))
    }, null, 2),
    (_ctx.port)
      ? (_openBlock(), _createBlock(_component_board_port, {
          key: 0,
          class: _normalizeClass(["edge-port", { 'edge-port-reverse': _ctx.reversePort }]),
          port: _ctx.port
        }, null, 8, ["class", "port"]))
      : _createCommentVNode("", true)
  ]))
}